import { tintuc, lichsinhhoat, vanban, hoctap, tulieu, thongtin } from 'assets/images';
const features = [
  {
    title: 'Tin tức',
    imgSrc: tintuc,
    description: 'Các nội dung, tin tức luôn được cập nhật lên Tin tức để người dùng có thể theo dõi hàng ngày.'
  },
  {
    title: 'Lịch công tác',
    imgSrc: lichsinhhoat,
    description: 'Xem trực tiếp các lịch công tác của bạn trên ứng dụng Công tác Đảng.'
  },
  {
    title: 'Văn bản',
    imgSrc: vanban,
    description: 'Các văn bản đã được ban hành liên tục cập nhật'
  },
  {
    title: 'Học tập',
    imgSrc: hoctap,
    description: 'Cho phép người dùng học tập và thi trực tuyến trên ứng dụng Công tác Đảng.'
  },
  {
    title: 'Tư liệu',
    imgSrc: tulieu,
    description: 'Bao gồm các tư liệu, văn kiện về Đảng cộng sản Việt Nam.'
  },
  {
    title: 'Thông tin',
    imgSrc: thongtin,
    description: 'Xem thông tin cá nhân trên ứng dụng Công tác Đảng.'
  },
  {
    title: 'Tin tức',
    imgSrc: tintuc,
    description: 'Các nội dung, tin tức luôn được cập nhật lên Tin tức để người dùng có thể theo dõi hàng ngày.'
  },
  {
    title: 'Lịch công tác',
    imgSrc: lichsinhhoat,
    description: 'Xem trực tiếp các lịch công tác của bạn trên ứng dụng Công tác Đảng.'
  },
  {
    title: 'Văn bản',
    imgSrc: vanban,
    description: 'Các văn bản đã được ban hành liên tục cập nhật'
  },
  {
    title: 'Học tập',
    imgSrc: hoctap,
    description: 'Cho phép người dùng học tập và thi trực tuyến trên ứng dụng Công tác Đảng.'
  },
  {
    title: 'Tư liệu',
    imgSrc: tulieu,
    description: 'Bao gồm các tư liệu, văn kiện về Đảng cộng sản Việt Nam.'
  },
  {
    title: 'Thông tin',
    imgSrc: thongtin,
    description: 'Xem thông tin cá nhân trên ứng dụng Công tác Đảng.'
  }
];

export default features;
